function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "delete_svg__a",
  d: "M268 32c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V20h-12v12zm13-15h-3.5l-1-1h-5l-1 1H267v2h14v-2z"
}));
var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#545454",
  fillRule: "nonzero",
  xlinkHref: "#delete_svg__a",
  transform: "translate(-267 -16)"
});
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='14' height='18' viewBox='0 0 14 18'%3e %3cdefs%3e %3cpath id='prefix__a' d='M268 32c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V20h-12v12zm13-15h-3.5l-1-1h-5l-1 1H267v2h14v-2z'/%3e %3c/defs%3e %3cg fill='none' fill-rule='evenodd' transform='translate(-267 -16)'%3e %3cuse fill='%23545454' fill-rule='nonzero' xlink:href='%23prefix__a'/%3e %3c/g%3e %3c/svg%3e";
export { SvgDelete as ReactComponent };